/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCButton from "../../buttons";

/* Styles */
import styles from "./styles";

const Footer = ({
  onCancel,
  onConfirm,
  confirmText,
  cancelText,
  isConfirmDisabled,
  radioListButtonSpinner
}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  
  return (
    <ContainerFluid>
      <Row>
        <Col className={classes.colCancel}>
          <UCButton onClick={onCancel} type="default" className={classes.cancelBtn} text={cancelText} />
        </Col>
        <Col className={classes.colChange}>
          <UCButton
            spinner={{
              name: radioListButtonSpinner,
              size: 20,
            }}
            onClick={onConfirm}
            type="primary"
            className={classes.saveBtn}
            text={confirmText}
            disabled={isConfirmDisabled}
          />
        </Col>
      </Row>
    </ContainerFluid>
  );
};

export default Footer;
